/** @deprecated Use icons from icons-v2-generated instead. */
export function ScriptIcon({
  className = 'w-5 h-5',
  size = 22,
  color = 'white',
}: {
  className?: string;
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 22"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.3755 17V14C19.3755 13.1075 19.6647 12.2384 20.2002 11.5244L20.5928 11L20.2002 10.4756C19.6647 9.76159 19.3755 8.89247 19.3755 8V5C19.3755 3.96463 18.5358 3.12526 17.5005 3.125H16.5C15.8787 3.125 15.375 2.62132 15.375 2C15.375 1.37868 15.8787 0.875 16.5 0.875H17.5005C19.7784 0.875264 21.6255 2.72199 21.6255 5V8C21.6255 8.40567 21.7571 8.80046 22.0005 9.125L22.8999 10.3247C23.1999 10.7247 23.1999 11.2753 22.8999 11.6753L22.0005 12.875C21.7571 13.1995 21.6255 13.5943 21.6255 14V17C21.6255 19.278 19.7784 21.1247 17.5005 21.125H16.5C15.8787 21.125 15.375 20.6213 15.375 20C15.375 19.3787 15.8787 18.875 16.5 18.875H17.5005C18.5358 18.8747 19.3755 18.0354 19.3755 17Z" />
      <path d="M2.375 17V14C2.375 13.645 2.27467 13.298 2.08642 12.9995L2 12.875L1.10058 11.6753C0.800619 11.2753 0.800619 10.7247 1.10058 10.3247L2 9.125L2.08642 9.00049C2.27467 8.70196 2.375 8.35497 2.375 8V5C2.375 2.72183 4.22182 0.875 6.5 0.875H7.50049L7.61474 0.880859C8.1821 0.938402 8.62549 1.41746 8.62549 2C8.62549 2.58254 8.1821 3.0616 7.61474 3.11914L7.50049 3.125H6.5C5.46446 3.125 4.625 3.96447 4.625 5V8C4.625 8.78089 4.40335 9.54346 3.98926 10.2002L3.80029 10.4756L3.40625 11L3.80029 11.5244L3.98926 11.7998C4.40335 12.4565 4.625 13.2191 4.625 14V17C4.625 18.0355 5.46446 18.875 6.5 18.875H7.50049L7.61474 18.8809C8.1821 18.9384 8.62549 19.4175 8.62549 20C8.62549 20.5825 8.1821 21.0616 7.61474 21.1191L7.50049 21.125H6.5C4.22182 21.125 2.375 19.2782 2.375 17Z" />
    </svg>
  );
}
